export type Status =
  | 'AUTORIZADO'
  | 'NEGADO'
  | 'EM_ANALISE'
  | 'SOLICITACAO_CANCELADA'

export enum OBSERVATION {
  NOT_FOUND = 'Guia não encontrada',
}

export enum ATTENDANCE_FLOW {
  SYNC = 'SINCRONO',
  ASYNC = 'ASSINCRONO',
  WITHOUT_GUIDE = 'SEM_GUIA',
}

export type GetAuthorizationDataRaw = {
  autorizado: boolean
  status: Status | null
  cid: string | null
  executado: boolean
  token: string | null
  observacao: string | null
  codigo_glosa: string | null
  mensagem_glosa: string | null
  fluxo_atendimento: string | null
  dados_autorizacao: {
    numero_guia_prestador?: string
    numero_guia_operadora?: string
    data_solicitacao?: string
    data_autorizacao?: string
    data_validade_senha?: string
    quantidade_solicitada?: number
    quantidade_autorizada?: number
    quantidade_utilizada?: number
    codigo_procedimento?: string
    descricao_procedimento?: string
    numero_carteirinha?: string
  } | null
  registro_ans: string | null
}
export type GetAuthorizationData = {
  isAuthorized: boolean
  status: Status | null
  cid: string | null
  isExecuted: boolean
  token: string | null
  observation: string | null
  codeGloss: string | null
  messageGloss: string | null
  attendanceFlow: string | null
  isWithoutGuide: boolean
  authorizationData: {
    providerGuideNumber?: string
    operatorGuideNumber?: string
    requestDateTime?: string
    authorizationDate?: string
    passwordValidityDate?: string
    requestedQuantity?: number
    authorizedQuantity?: number
    usedQuantity?: number
    procedureCode?: string
    procedureDescription?: string
    cardNumber?: string
  } | null
  ansRecord: string | null
  guideNotFound: boolean
  formattedRequestDateTime: string
}
